import React from 'react';
import { Modal, Button } from 'antd';

export default class ConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.visible || false,
    };
    this.close = this.close.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }

  onConfirm(event) {
    if (event) event.preventDefault();
    this.props.onConfirm();
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  close() {
    this.setState({ showModal: false });
  }

  render() {
    return (
      <Modal
        title={this.props.title}
        visible={this.state.showModal}
        onCancel={this.close}
        footer={[
          <Button key="back" onClick={this.close}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            danger={this.props.confirmButtonStyle === 'btn-danger'}
            onClick={this.onConfirm}
          >
            {this.props.confirmButton}
          </Button>,
        ]}
      >
        <p>{this.props.body}</p>
      </Modal>
    );
  }
}

